import 'vuetify/styles'; 
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#00549e',
          secondary: '#01a8ba',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#01a8ba',
          success: '#4CAF50',
          warning: '#FFC107',
        },
      },
    },
  },
});
